import React, { Component } from "react";
import styles from "./styles";
import classNames from "classnames";
import PropTypes, { object } from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { canvas as canvasStore, filters, pois } from "../../store";
import { Button, withStyles } from "@material-ui/core";
import { ReactComponent as ArrowLeftIcon } from "../../assets/images/icons/arrowLeft.svg";
import { ReactComponent as ArrowRightIcon } from "../../assets/images/icons/arrowRight.svg";
import { Popup } from "./partials";

import { ReactComponent as LightOnIcon } from "../../assets/images/icons/light-on.svg";
import { ReactComponent as LightOffIcon } from "../../assets/images/icons/light-off.svg";
import { theme } from "../../utils";
import * as PIXI from "pixi.js";

import Draggable from "gsap/Draggable";
import lciHelper from "./partials/lci";
import { Viewport } from "pixi-viewport";
import { ProgressBar } from "../../components";
import { version } from "../../config";
import Tooltip from "@material-ui/core/Tooltip";

const isOffice = version.office;

let Animator = null;
let AnimatorSprite = null;
let CanvasContainer = null;
let self = null;
const GLOBAL_POIS = {};
const GLOBAL_POLYGONS = {};
const GLOBAL_TEXTURES = {};

const threeDButtonRadius = 19;
const threeDButtonLeftOffset = -5;
const invertXRotations = true;

class Canvas extends Component {

	constructor(props) {
		super(props);
		self = this;
	}

	state = {
		progress: this.isLoaded ? 100 : 0,
		frames: [],
		framesCount: 90,
		counter: 1,
		zoom: 1,
		maxZoom: 2,
		filteredIds: [],
		pois: {},
		floors: {},
		loaded: 0,
		startX: null,
		startY: null,
		stage: null,
		canvas: null,
		popup: {
			x: 0,
			y: 0,
			open: false,
			poi: null,
			color: "inherit"
		},
		direction: 1,
		mouseTrigger: false,
		rollInterval: false,
		stateLights: true,
		currentPOI: false,
		isInit: true
	};

	holdInterval = false;
	isLoaded = false;


	componentDidMount() {
		let { helperChooser } = this.props;
		const { setFrame } = this.props;

		if (this.props.poi) {
			helperChooser = "lci";
		}
		switch (helperChooser) {
		case "floor":
			break;
		case "lci":
			const frame = lciHelper.findLci(this);
			setFrame(frame);
			break;
		default:
			break;
		}
		this.setState({
			framesCount: this.props.floorsImages.all.length - 1
		});
		this.props.fetchPois();
		this.init();
	}

	componentDidUpdate(prevProps) {
		const { filteredIds, stateLights } = this.state;
		const { ids, lights, floor, hoveredLot, hasFloors, poiId } = this.props;

		if (this.isLoaded) {
			if (JSON.stringify(filteredIds) !== JSON.stringify(ids)) {
				this.setState({ filteredIds: ids });
			}
			if (lights !== stateLights) {
				this.setState({
					stateLights: lights
				});
			}
			if (JSON.stringify(prevProps.floor) !== JSON.stringify(floor)) {
				this.setAssets();
			}

			if (version.office && prevProps.poiId !== poiId) {
				this.onAssetsLoaded();
			}

			if (prevProps.hoveredLot !== hoveredLot) {
				if (
					!(
						hasFloors &&
						((typeof floor === "string" && floor !== "all") ||
							(typeof floor === "object" && floor[0] !== "all"))
					)
				) {
					if (hoveredLot) {
						AnimatorSprite.children.forEach(circle => {
							if (!circle.isLci && circle.lot === hoveredLot) {
								circle.clear();
								circle.beginFill(circle.textColor, 1);
								circle.drawCircle(
									threeDButtonLeftOffset,
									0,
									threeDButtonRadius
								);
								circle.endFill();
								if (circle.children && circle.children.length > 0) {
									circle.children[0].style = {
										fontFamily: ["Inter", "Questrial", "Arial", "sans", "sans-serif"],
										fontSize: 16,
										fill: circle.color,
										align: "center"
									};
								}
							}
						});
					} else {
						AnimatorSprite.children.forEach(circle => {
							if (!circle.isLci) {
								circle.clear();
								circle.beginFill(circle.color, 1);
								circle.drawCircle(
									threeDButtonLeftOffset,
									0,
									threeDButtonRadius
								);
								circle.endFill();
								if (circle.children && circle.children.length > 0) {
									circle.children[0].style = {
										fontFamily: ["Inter", "Questrial", "Arial", "sans", "sans-serif"],
										fontSize: 16,
										fill: circle.textColor,
										align: "center"
									};
								}
							}
						});
					}
				}
			}
			this.setUpdateState();
		}
	}

	setTextures() {
		return new Promise((resolve, reject) => {
			const promises = [];
			const { floor, floorsImages } = this.props;
			// if (!GLOBAL_TEXTURES[floor]) {
			// 	this.loadFloorTextures(floor).then(() => {
			// 		resolve(true);
			// 		this.setTextures().then(() => {
			// 			console.log(true);
			// 		});
			// 	});
			// } else {
			const floors = Object.keys(floorsImages);
			floors.forEach(fl => {
				if (floor !== fl && !GLOBAL_TEXTURES[fl]) {
					promises.push(this.loadFloorTextures(fl));
				}
			});
			Promise.all(promises).then(() => {
				resolve(true);
			});
			// }
		});
	}

	updateGlobalFrame(isMulti = false) {
		const { ids, lights, frame } = self.props;
		let data = GLOBAL_POIS;
		if (isMulti) {
			data = GLOBAL_POLYGONS;
		}
		Object.keys(data).map(lot => {
			const child = data[lot];
			let coord = child.columns[frame];
			if (
				!coord ||
				(this.props.poi && this.props.poi !== lot) ||
				ids.indexOf(lot) === -1 ||
				!lights
			) {
				if (isMulti) {
					coord = [-1920, -1080];
				} else {
					coord = { x: -1920, y: -1080 };
				}
			}

			if (isMulti) {
				child.clear();
				child.beginFill(child.color);
				child.drawPolygon(coord);
			} else {
				const { x, y } = coord;
				child.x = x;
				child.y = y;
			}
			return child;
		});

		AnimatorSprite.gotoAndStop(this.props.frame);
	}

	updateImage(event) {
		if (
			event &&
			(event.which === 2 || event.button === 4 || event.buttons === 4)
		) {
			return true;
		}
		return self.rotate(
			Number((invertXRotations ? 1 : -1) * Math.sign(this.deltaX))
		);

		self.setState(state => ({
			counter: state.counter + this.deltaX * 0.2
		}));

		const count = self.state.framesCount - 1;
		let index = Math.round(((self.state.counter % 360) / 360) * count);

		index = index < 1 ? count + index : index - 1;

		self.props.setFrame(index);

		self.setUpdateState();
		return true;
	}

	checkOuterLimits = frame => {
		const { framesCount } = this.state;

		if (frame >= framesCount) {
			return 0;
		}
		if (frame < 0) {
			return framesCount - 1;
		}
		return frame;
	};

	pointsOnMap = (svgColor, circle, color, text) => {
		let _svgCol = "#E6007E";

		let svg360 = `<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.5454 29.3636L17 30.9091L18.5454 32.4545" stroke="#FFFFFF" stroke-linecap="square"/>
<path d="M10.4562 4.46483C12.1926 2.6071 14.5446 1.55794 17.0003 1.54545C19.4559 1.55795 21.8075 2.60731 23.5438 4.465C25.2804 6.32252 26.2611 8.83868 26.2728 11.4658V11.798C26.2692 14.2166 25.432 16.5487 23.9213 18.3481L18.1978 24.8505L17.0003 26.2727L15.8021 24.898L10.3894 18.3956C8.73837 16.5125 7.79112 14.0464 7.72729 11.4656C7.73897 8.83855 8.71972 6.32235 10.4562 4.46483Z" stroke="#FFFFFF"/>
<path d="M19.3182 30.9091C20.2219 30.8818 21.1 30.8387 21.9453 30.7813C28.0553 30.3665 32.4546 29.2044 32.4546 27.8355C32.4546 26.561 28.6401 25.4656 23.1819 24.9859M9.66496 30.5721C4.83017 30.0468 1.5455 29.0183 1.5455 27.8355C1.5455 26.561 5.35997 25.4656 10.8182 24.9859" stroke="#FFFFFF"/>
<path d="M21.1363 10.8182C21.1363 13.1026 19.2843 14.9545 16.9999 14.9545C14.7154 14.9545 12.8635 13.1026 12.8635 10.8182C12.8635 8.53373 14.7154 6.68182 16.9999 6.68182C19.2843 6.68182 21.1363 8.53373 21.1363 10.8182Z" stroke="#FFFFFF" />
</svg>
`;
		let visibilityIcon;
		if (version.office) {
			let texture;
			if (circle.pedestrian) {
				texture = PIXI.Texture.from(svg360);
			}
			visibilityIcon = new PIXI.Sprite(texture);
		}

		//var color = Math.floor(Math.random() * 0xFFFFFF);
		if (circle.pedestrian === "false") {
			circle.beginFill(0xFEFDF8, 0.8);
			circle.drawRect(0, 0, 130, 50);
			let txtVue = new PIXI.Text(circle.floor, {
				fontFamily: [
					"Inter",
					// "Questrial",
					"Arial",
					"sans",
					"sans-serif"
				],
				fontSize: 16,
				fill: "rgb(230,0,126)",
				align: "center"
			});
			txtVue.x = 45;
			txtVue.y = 7;

			circle.addChild(txtVue);

			let txtDesc = new PIXI.Text(circle.label, {
				fontFamily: [
					"Inter",
					// "Questrial",
					"Arial",
					"sans",
					"sans-serif"
				],
				fontSize: 16,
				fill: "#000000",
				align: "center"
			});
			txtDesc.x = 1;
			txtDesc.y = 24;
			circle.addChild(txtDesc);
			circle.endFill();
		} else {
			circle.beginFill(0x000000, 0.8);
			circle.drawCircle(0, 0, 30);
			circle.addChild(visibilityIcon);
			circle.endFill();
		}
		//


		if (visibilityIcon) {
			visibilityIcon.x = -18;
			visibilityIcon.y = -14;
		}
	};

	onAssetsLoaded = () => {
		const proxyTrigger = document.getElementById("proxyTrigger");
		const proxy = document.getElementById("proxy");
		const { poiId } = self.props;
		const { width } = Animator.renderer;
		const { height } = Animator.renderer;
		const worldWidth = Animator.renderer.width;
		const worldHeight = Animator.renderer.height;
		const worldMinX = 0;
		const worldMinY = 0;
		const worldMaxX = worldWidth;
		const worldMaxY = worldHeight;

		if (CanvasContainer) {
			CanvasContainer.destroy();
			CanvasContainer = null;
		}

		CanvasContainer = new Viewport({
			screenWidth: width,
			screenHeight: height,
			worldWidth,
			worldHeight,
			interaction: Animator.renderer.plugins.interaction,
			noTicker: true
		});

		this.initAnimatedSprite("all");
		CanvasContainer.addChild(AnimatorSprite);

		let currentFloorPois = this.props.pois;
		currentFloorPois.forEach(item => {
			const [lot] = Object.keys(item);
			const poi = item[lot];
			let X = 0;
			let Y = 0;

			const circle = new PIXI.Graphics();
			// Opt-in to interactivity
			circle.interactive = true;

			circle.pedestrian = poi.data.pedestrian;
			circle.label = poi.data.label;
			circle.floor = poi.data.floor == 0 ? "RDC" : "R + " + poi.data.floor;


			// Shows hand cursor
			circle.buttonMode = true;
			circle.lineStyle(0);
			//	const textColor = parseInt(`0x${"#ffffff".slice(1)}`, 16); // theme.palette.primary.contrastText;
			const textColor = parseInt(`0x${"#FF8931".slice(1)}`, 16); // theme.palette.primary.contrastText;

			let type = !isOffice ? this.props.data[lot].type.replace(/\D/u, "") : 1;
			if (
				this.props.data[lot].type === "ST" ||
				this.props.data[lot].type === "st"
			) {
				type = 1;
			}
			let color = theme.app[`backgroundColor${type}`];
			if (!color) {
				color = theme.app.default;
			} else if (version.office) {
				color = poiId === lot ? "#ffffff" : "#000";
				color = "#FEFDF8";
			}

			color = parseInt(`0x${color.slice(1)}`, 16);
			let text = new PIXI.Text(lot, {
				fontFamily: [
					"Inter",
					// "Questrial",
					"Arial",
					"sans",
					"sans-serif"
				],
				fontSize: 16,
				fill: "#FF8931",
				align: "center"
			});

			//this.pointsOnMap(
			//	version.office && poiId === lot ? "black" : "white",
			//	circle,
			//  color,
			// 	text
			//);
			this.pointsOnMap(
				"#FF8931",
				circle,
				color,
				text
			);

			circle.columns = {};
			circle.lot = lot;
			circle.color = color;
			circle.textColor = textColor;

			poi.coordinates.forEach(coordinate => {
				const frame = Number(coordinate._column);
				X = coordinate._x * 1920;
				Y = coordinate._y * 1080;

				circle.columns[frame] = {
					x: X,
					y: Y
				};

				text.x = 0 - 20;
				text.y = 0 - 10;

				if (frame === this.props.frame) {
					circle.x = X;
					circle.y = Y;
				}
			});

			circle.on("mouseover", () => {
				version.office && this.props.setPoiId(lot);
				circle.clear();
				this.pointsOnMap("#FFBD54", circle, color, text);

				text.style = {
					fontFamily: ["Inter", "Questrial", "Arial", "sans", "sans-serif"],
					fontSize: 16,
					fill: color,
					align: "center"
				};
				return false;
			});

			circle.on("mouseout", () => {
				version.office && this.props.setPoiId();
				this.pointsOnMap("#FF8931", circle, color, text);

				text.style = {
					fontFamily: ["Inter", "Questrial", "Arial", "sans", "sans-serif"],
					fontSize: 16,
					fill: textColor,
					align: "center"
				};

				return false;
			});

			circle.on("click", () => this.onEyeClick(lot));

			circle.on("tap", () => this.onEyeClick(lot));

			GLOBAL_POIS[lot] = circle;
			CanvasContainer.addChild(circle);
		});

		CanvasContainer.left = worldMinX;
		CanvasContainer.top = worldMinY;
		CanvasContainer.right = worldMaxX;
		CanvasContainer.bottom = worldMaxY;
		CanvasContainer.fitWidth(worldWidth, false, false)
			.fitHeight(worldHeight, false, false)
			.drag({
				mouseButtons: "middle"
			})
			.wheel({
				percent: 0.1
			})
			.decelerate()
			.clampZoom({
				minWidth: worldWidth / 1.5,
				minHeight: worldHeight / 1.5,
				maxWidth: worldWidth,
				maxHeight: worldHeight
			})
			.clamp({
				left: worldMinX,
				right: worldMinX + worldWidth,
				top: worldMinY,
				bottom: worldMinY + worldHeight
			});
		Animator.stage.addChild(CanvasContainer);

		Draggable.create(proxy, {
			type: "x",
			throwProps: true,
			trigger: proxyTrigger,
			onDrag: this.updateImage,
			onThrowUpdate: this.updateImage,
			cursor: "arrow",
			maxDuration: 2.0,
			lockAxis: true
		});
	};

	onEyeClick = lot => {
		sessionStorage.setItem("hash", window.location.hash);
		this.props.history.push(`/lot/${lot}`);
		version.office && this.props.setPoiId();
		return false;
	};

	onAssetsLoadedMultiFloor = () => {
		let { floor, data } = this.props;
		const proxyTrigger = document.getElementById("proxyTrigger");
		const proxy = document.getElementById("proxy");

		const { width } = Animator.renderer;
		const { height } = Animator.renderer;
		const worldWidth = Animator.renderer.width;
		const worldHeight = Animator.renderer.height;
		const worldMinX = 0;
		const worldMinY = 0;
		const worldMaxX = worldWidth;
		const worldMaxY = worldHeight;

		if (typeof floor !== "string") {
			floor = floor[0];
		}

		this.initAnimatedSprite(floor);

		CanvasContainer = new Viewport({
			screenWidth: width,
			screenHeight: height,
			worldWidth,
			worldHeight,
			interaction: Animator.renderer.plugins.interaction,
			noTicker: true
		});

		CanvasContainer.addChild(AnimatorSprite);
		CanvasContainer.left = worldMinX;
		CanvasContainer.top = worldMinY;
		CanvasContainer.right = worldMaxX;
		CanvasContainer.bottom = worldMaxY;
		CanvasContainer.fitWidth(worldWidth, false, false)
			.fitHeight(worldHeight, false, false)
			.drag({
				mouseButtons: "middle"
			})
			.wheel({
				percent: 0.1
			})
			.decelerate()
			.clampZoom({
				minWidth: worldWidth / 1.5,
				minHeight: worldHeight / 1.5,
				maxWidth: worldWidth,
				maxHeight: worldHeight
			})
			.clamp({
				left: worldMinX,
				right: worldMinX + worldWidth,
				top: worldMinY,
				bottom: worldMinY + worldHeight
			});
		CanvasContainer.mousemove = event => {
			// self.setState(prevState => {
			// 	prevState.popup.x = event.data.originalEvent.clientX - 90;
			// 	prevState.popup.y = event.data.originalEvent.clientY + 24;
			// 	return {
			// 		...prevState
			// 	};
			// });
		};

		const currentFloorPois = this.props[floor].pois;

		currentFloorPois.forEach(item => {
			const [lot] = Object.keys(item);
			const poi = item[lot];
			const vertices = {};
			const columns = [];

			const polygon = new PIXI.Graphics();

			const textColor = parseInt(`0x${"#ffffff".slice(1)}`, 16); // theme.palette.primary.contrastText;
			let type = !isOffice ? this.props.data[lot].type.replace(/\D/u, "") : 1;
			if (
				this.props.data[lot].type === "ST" ||
				this.props.data[lot].type === "st"
			) {
				type = 1;
			}
			let color = theme.app[`backgroundColor${type}`];
			//ICI COULEUR

			if (!color) {
				color = theme.app.default;
				color = "#F89470";
			}

			switch (poi.data.typeColor) {
			case "commerce":
				color = "#fad645";
				break;
			case "bureau":
				color = "#648fea";
				break;
			case "service":
				color = "#ff537b";
				break;
			default:
				color = "#F89470";
			}


			const nativeColor = color;

			color = parseInt(`0x${color.slice(1)}`, 16);

			const text = new PIXI.Text(lot, {
				fontFamily: [
					"Inter",
					// "Questrial",
					"Arial",
					"sans",
					"sans-serif"
				],
				fontSize: 16,
				fill: textColor,
				align: "center"
			});
			// polygon.coordinates = vertices;
			if (!polygon.columns) {
				polygon.columns = [];
			}

			polygon.lot = lot;
			polygon.color = color;
			polygon.textColor = textColor;
			polygon.beginFill(color);
			polygon.hitArea = vertices[self.state.frame];
			polygon.interactive = true;
			polygon.buttonMode = true;
			polygon.alpha = 0.7;
			polygon.mouseover = () => {
				if (!self.state.popup.open) {
					polygon.alpha = 0.5;
				}
			};
			polygon.mouseout = () => {
				if (!self.state.popup.open) {
					polygon.alpha = 0.7;
				}
			};

			if(poi.data.visit360 !== ""){
				polygon.on("tap", () => this.onEyeClick(lot));
			}

			polygon.on("click", (e) => {
				if (self.state.popup.open) {
					polygon.alpha = 0.7;
				}
				polygon.alpha = 1;

				self.setState({
					popup: {
						open: true,
						color: nativeColor,
						poi: data[lot],
						onClickPoi: this.onEyeClick,
						onClose: () => {
							polygon.alpha = 0.7;
							self.setState({
								popup: {
									open: false
								}
							});
						},
						x: e.data.global.x - 200,
						y: e.data.global.y + 50
					}
				});
			});
			poi.coordinates.forEach(coordinate => {
				const vert = [];
				coordinate._vertices.split(";").forEach(vertice => {
					const tmp = vertice.split(",");
					vert.push({
						x: 1920 * tmp[0],
						y: 1080 * tmp[1]
					});
				});
				const frame = coordinate._column;
				polygon.columns[frame] = vert;
			});

			GLOBAL_POLYGONS[lot] = polygon;
			CanvasContainer.addChild(polygon);
		});

		Animator.stage.addChild(CanvasContainer);

		Draggable.create(proxy, {
			type: "x",
			throwProps: true,
			trigger: proxyTrigger,
			onDrag: this.updateImage,
			onThrowUpdate: this.updateImage,
			cursor: "arrow",
			maxDuration: 2.0,
			lockAxis: true
		});
	};

	onAssetsLoadedLci = () => {
		const proxyTrigger = document.getElementById("proxyTrigger");
		const proxy = document.getElementById("proxy");

		const { width } = Animator.renderer;
		const { height } = Animator.renderer;
		const worldWidth = Animator.renderer.width;
		const worldHeight = Animator.renderer.height;
		const worldMinX = 0;
		const worldMinY = 0;
		const worldMaxX = worldWidth;
		const worldMaxY = worldHeight;

		CanvasContainer = new Viewport({
			screenWidth: width,
			screenHeight: height,
			worldWidth,
			worldHeight,
			interaction: Animator.renderer.plugins.interaction,
			noTicker: true
		});

		this.initAnimatedSprite("all");

		CanvasContainer.addChild(AnimatorSprite);

		CanvasContainer.addChild(AnimatorSprite);
		CanvasContainer.left = worldMinX;
		CanvasContainer.top = worldMinY;
		CanvasContainer.right = worldMaxX;
		CanvasContainer.bottom = worldMaxY;
		CanvasContainer.fitWidth(worldWidth, false, false)
			.fitHeight(worldHeight, false, false)
			.drag({
				mouseButtons: "middle"
			})
			.wheel({
				percent: 0.1
			})
			.decelerate()
			.clampZoom({
				minWidth: worldWidth / 1.5,
				minHeight: worldHeight / 1.5,
				maxWidth: worldWidth,
				maxHeight: worldHeight
			})
			.clamp({
				left: worldMinX,
				right: worldMinX + worldWidth,
				top: worldMinY,
				bottom: worldMinY + worldHeight
			});
		Animator.stage.addChild(CanvasContainer);

		let currentFloorPois = this.props.pois;
		currentFloorPois.forEach(item => {
			const [lot] = Object.keys(item);
			if (this.props.poi === lot) {
				const lciCircle1 = new PIXI.Graphics();
				const lciRectangle = new PIXI.Graphics();
				const lciCircle2 = new PIXI.Graphics();
				const lciCircle3 = new PIXI.Graphics();
				const lci = new PIXI.Container();

				const textColor = parseInt(`0x${"#ffffff".slice(1)}`, 16); // theme.palette.primary.contrastText;
				let type = this.props.data[lot].type.replace(/\D/u, "");
				if (
					this.props.data[lot].type === "ST" ||
					this.props.data[lot].type === "st"
				) {
					type = 1;
				}
				let color = theme.app[`backgroundColor${type}`];
				if (!color) {
					color = theme.app.default;
					color = "#FFFFFF";
				}

				color = parseInt(`0x${color.slice(1)}`, 16);

				const lciText = new PIXI.Text("lci", {
					fontFamily: [
						"Inter",
						"Arial",
						"sans",
						"sans-serif"
					],
					fontSize: 24,
					fill: color,
					align: "center"
				});

				lciCircle1.lineStyle(0);
				lciCircle1.beginFill(0xffffff, 1);
				lciCircle1.drawCircle(-120, 0, 25);
				lciCircle1.endFill();
				lciText.x = -133;
				lciText.y = -15;
				lciCircle1.addChild(lciText);

				lciRectangle.beginFill(0xffffff);
				lciRectangle.drawRect(-110, -5, 60, 10);
				lciRectangle.endFill();
				lciCircle2.lineStyle(0);
				lciCircle2.beginFill(0xffffff, 1);
				lciCircle2.drawCircle(-50, 0, 12);
				lciCircle2.endFill();
				lciCircle3.lineStyle(10, color, 1);
				lciCircle3.beginFill(0xffffff, 0);
				lciCircle3.drawCircle(0, 0, 50);
				lciCircle3.endFill();
				lci.addChild(lciRectangle);
				lci.addChild(lciCircle3);
				lci.addChild(lciCircle1);
				lci.addChild(lciCircle2);
				lci.lot = lot;
				lci.color = color;
				lci.textColor = textColor;

				const poi = item[lot];
				let X = 0;
				let Y = 0;
				let Xlci = 0;
				let Ylci = 0;
				const vertices = {};
				if (!lci.columns) {
					lci.columns = {};
				}

				poi.coordinates.forEach(coordinate => {
					const frame = coordinate._column;
					lci.columns[frame] = {
						x: coordinate._x * 1920,
						y: coordinate._y * 1080
					};
					if (frame === this.props.frame) {
						lci.x = lci.columns[frame].x;
						lci.y = lci.columns[frame].y;
					}
				});

				lci.isLci = true;

				GLOBAL_POIS[lot] = lci;
				CanvasContainer.addChild(lci);
			}
		});

		Draggable.create(proxy, {
			type: "x",
			throwProps: true,
			trigger: proxyTrigger,
			onDrag: this.updateImage,
			onThrowUpdate: this.updateImage,
			cursor: "arrow",
			maxDuration: 2.0,
			lockAxis: true
		});
	};

	init() {
		const $target = document.getElementById("target");
		Animator = new PIXI.Application({
			width: 1920,
			height: 1080,
			transparent: true,
			backgroundColor: 0xffffff,
			// resizeTo: $target,
			antialias: true,
			forceCanvas: true
		});
		$target.appendChild(Animator.view);
		if (!this.isLoaded) {
			this.firstLaunch();
			this.setAssets();
			this.setTextures().then(() => {
				this.isLoaded = true;
				this.setAssets();
				this.setUpdateState();

				this.setState({ progress: 100 });
			});
			this.setUpdateState();
		} else {
			this.setAssets();
			this.setState({ progress: 100 });
			this.setUpdateState();
		}
	}

	firstLaunch() {
		let { floorsImages, floor, hasFloors } = this.props;
		// if(typeof floor === "object" && (floor.length === 0 || floor.indexOf("all") < 0)) {
		// 	floor.push("all");
		// }

		if (!hasFloors) {
			floor = "all";
		}

		const floorImages = floorsImages[floor];

		GLOBAL_TEXTURES[floor] = [];

		floorImages.forEach((image, index) => {
			GLOBAL_TEXTURES[floor].push(PIXI.Texture.from(image));
		});
	}

	initAnimatedSprite(floor) {
		AnimatorSprite = new PIXI.AnimatedSprite(GLOBAL_TEXTURES[floor]);

		AnimatorSprite.x = Animator.renderer.width / 2;
		AnimatorSprite.y = Animator.renderer.height / 2;
		AnimatorSprite.width = Animator.renderer.width;
		AnimatorSprite.height = Animator.renderer.height;
		AnimatorSprite.anchor.set(0);
		AnimatorSprite.loop = true;
		AnimatorSprite.animationSpeed = 0.0001;
		AnimatorSprite.position.x = 0;
		AnimatorSprite.position.y = 0;
	}

	loadFloorTextures(floor) {
		const { floorsImages } = this.props;
		const floorImages = floorsImages[floor];
		const pixiLoader = new PIXI.Loader();
		return new Promise((resolve, reject) => {
			if (!GLOBAL_TEXTURES[floor]) {
				pixiLoader.onComplete.add(f => {
					if (this.state.progress < f.progress) {
						this.setState({ progress: f.progress });
					}
					resolve();
				});
				pixiLoader.onProgress.add(f => {
					if (this.state.progress < f.progress) {
						this.setState({ progress: f.progress });
					}
				});
				floorImages.forEach((image, index) => {
					pixiLoader.add(`${floor}-${index}`, image);
				});

				pixiLoader.load((loader, resources) => {
					GLOBAL_TEXTURES[floor] = Object.keys(resources).map(key => {
						return resources[key];
					});
				});
			}
		});
	}

	setAssets() {
		const { poi, floor, hasFloors } = this.props;
		if (poi) {
			this.onAssetsLoadedLci();
		} else if (
			hasFloors &&
			((typeof floor === "string" && floor !== "all") ||
				(typeof floor === "object" && floor[0] !== "all"))
		) {
			this.onAssetsLoadedMultiFloor();
		} else {
			this.onAssetsLoaded();
		}
	}

	setUpdateState() {
		const { poi, floor, hasFloors } = this.props;
		const isMulti =
			!poi &&
			hasFloors &&
			((typeof floor === "string" && floor !== "all") ||
				(typeof floor === "object" && floor[0] !== "all"));

		this.updateGlobalFrame(isMulti);
	}

	holdAnimation = dir => {
		if (!this.holdInterval) {
			this.holdInterval = setInterval(() => {
				this.props.setFrame(this.checkOuterLimits(this.props.frame + dir));
				this.setUpdateState();
			}, 100);
		}
	};

	endAnimation = () => {
		if (this.holdInterval) {
			clearInterval(this.holdInterval);
			this.holdInterval = false;
		}
	};

	rotate(dir) {
		// if ((!this.props.poi && this.holdInterval) || this.props.poi) {
		this.props.setFrame(this.checkOuterLimits(this.props.frame - dir));
		this.setUpdateState();
		// }
	}

	render() {
		const { classes, poi, lights, toggleLights, hasFloors, floor } = this.props;
		const { popup } = this.state;

		return (
			<div
				style={{
					position: "relative"
				}}
			>

				<div id="proxyTrigger">
					<div id="target" />
					<div id="proxy" />
				</div>

				<Popup popup={popup} />
				<div className={classes.arrowsContainer}>
					<Button
						className={classNames(classes.arrows, classes.arrowLeft)}
						variant="contained"
						color="primary"
						onMouseDown={() => {
							this.holdAnimation(invertXRotations ? -1 : 1);
						}}
						onMouseUp={this.endAnimation}
						onTouchStart={() => {
							this.holdAnimation(invertXRotations ? -1 : 1);
						}}
						onTouchEnd={this.endAnimation}
						onMouseLeave={this.endAnimation}
						onClick={() => this.rotate(invertXRotations ? 1 : -1)}
					>
						<ArrowLeftIcon className={classNames(classes.arrowIcon)} />
					</Button>
					<Button
						className={classNames(classes.arrows, classes.arrowRight)}
						variant="contained"
						color="primary"
						onMouseDown={() => {
							this.holdAnimation(invertXRotations ? 1 : -1);
						}}
						onMouseUp={this.endAnimation}
						onTouchStart={() => {
							this.holdAnimation(invertXRotations ? 1 : -1);
						}}
						onTouchEnd={this.endAnimation}
						onMouseLeave={this.endAnimation}
						onClick={() => this.rotate(invertXRotations ? -1 : 1)}
					>
						<ArrowRightIcon className={classNames(classes.arrowIcon)} />
					</Button>
				</div>
				<Button
					color="primary"
					variant="contained"
					className={classNames(classes.eyeContainer, classes.eye)}
					onClick={toggleLights}
				>
					{
						lights ? (
							<>
								<LightOnIcon
									className={classNames(classes.primaryColor, classes.eyeIco)}
								/>
								<span style={{
									margin: "3px",
									textTransform: "none"
								}}>Masquer les boutons</span>
							</>
						) : (
							<>
								<LightOffIcon
									className={classNames(
										classes.primaryColor,
										classes.eyeIco
									)}
								/>
								<span style={{
									margin: "3px",
									textTransform: "none"
								}}>Afficher les boutons</span>
							</>
						)}
				</Button>
				<ProgressBar progress={this.state.progress} />
			</div>
		);
	}

}

const mapStateToProps = state => {
	return {
		...state.filtered[state.helpers.building],
		...state.canvas[state.helpers.building],
		pois: state.canvas[state.helpers.building].all.pois,
		data: state.pois[state.helpers.building],
		lci: state.canvas[state.helpers.building].lci,
		floor: state.filters[state.helpers.building].floor,
		lights: state.canvas[state.helpers.building].lights,
		currentBuilding: state.helpers.building,
		poiId: state.pois.poi
	};
};

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setFloor: filters.setFloor,
			setCanvasImages: canvasStore.setCanvasImages,
			setFrame: canvasStore.setFrame,
			toggleLights: canvasStore.toggleLights,
			fetchPois: pois.fetchPois,
			setPoiId: pois.setHoveredPoiId
		},
		dispatch
	);

Canvas.propTypes = {
	classes: PropTypes.object.isRequired,
	floor: PropTypes.any.isRequired,
	// floors: PropTypes.object.isRequired,
	floorsImages: PropTypes.object.isRequired,
	frame: PropTypes.number.isRequired,
	hasFloors: PropTypes.bool.isRequired,
	// helperChooser: PropTypes.string.isRequired,
	ids: PropTypes.array.isRequired,
	lights: PropTypes.bool.isRequired,
	poi: PropTypes.any,
	pois: PropTypes.array.isRequired,
	shapes: PropTypes.object.isRequired
};

Canvas.defaultProps = {
	poi: false
};

export default withRouter(
	withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Canvas))
);
